/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';

/**
 * deleteCart
 * url - /checkout/{apiVersion}/cart/{cartId}?brand={brandId}
 *
 * @param {Object} args.wcEnv
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 */
const deleteCart =  ({
    env, jwtToken, cartId,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage = `${RESOURCE_PAGE_CARTSERVICE}/${cartId}`;

    return restClient.deleteRequest(envObj, resourcePage, jwtToken)
        .then((response) => response);
};

export default deleteCart;
